import React from 'react';

import { ActionLogTable } from './actionLogTable/ActionLogTable';
import AppModal from 'components/modal/appModal';
import { SimpleModalId } from 'constants/modalId';
import { ActionLogModalContentProps, ActionLogModalContentState } from './ActionLogContent.types';
import { callApi } from 'helpers/callApi/callApi';

export class ActionLogContent extends React.Component<ActionLogModalContentProps, ActionLogModalContentState> {
  state: ActionLogModalContentState = {
    data: [],
    loading: false,
    error: false,
  };

  componentDidMount(): void {
    const { fetchDataId, getData } = this.props;

    callApi({
      action: () => {
        this.setState({ loading: true });

        return getData(fetchDataId);
      },
      onSuccess: ({ payload }) => {
        this.setState({
          data: payload,
          loading: false,
          error: false,
        });
      },
      onFailure: () => this.setState({ data: [], loading: false, error: true }),
    });
  }

  render() {
    const { openDetails, name, type } = this.props;
    const { data, loading, error } = this.state;

    return (
      <AppModal id={SimpleModalId.ActionLog} title={`${type} action log - ${name}`} hideOpenButton>
        {error ? (
          <div>Something went wrong</div>
        ) : (
          <ActionLogTable data={data} openDetails={openDetails} loading={loading} />
        )}
      </AppModal>
    );
  }
}
